import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "twitter",
  "use": "twitter-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 90 90\" id=\"twitter\">\n  <path fill=\"#000\" d=\"M8.306 10.723 36.814 48.84 8.126 79.83h6.457L39.7 52.698l20.293 27.134h21.971L51.851 39.57l26.702-28.847h-6.456l-23.13 24.988-18.69-24.989H8.308Zm9.495 4.756h10.094l44.572 59.596H62.373L17.801 15.48Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol